import { useContext, useEffect, useRef } from 'react';

import { RTCService } from 'services';
import { VideoPlayer } from 'components';
import { CameraOffNewIcon, CameraOnNewIcon } from 'components/Icon';

import { backstageContext } from './Backstage.Provider';

import styles from './Backstage.module.scss';

export type CameraProps = {};

const Camera = (props: CameraProps): JSX.Element => {
  const {
    video: { track, muted, loading },
    toggleVideo: toggle
  } = useContext(backstageContext);

  const playerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (track && playerRef.current) {
      if (muted) {
        RTCService.stopVideo(track);
      } else {
        RTCService.playVideo(track, playerRef.current);
      }
    }
  }, [track, muted]);

  return (
    <div className={styles.container}>
      <button type="button" className={styles.cam} disabled={loading} onClick={toggle}>
        <VideoPlayer className={styles.player} ref={playerRef} />
        <p className={styles.title}>Tap to test</p>
        {muted ? <CameraOffNewIcon /> : <CameraOnNewIcon />}
      </button>
    </div>
  );
};

export default Camera;
